import React, { useEffect, useRef, useState } from 'react';

const FadeInAnimation = ({
    children,
    delay = 0,
    animateOnce = true,
    className = '',
    style = {}
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [hasAnimated, setHasAnimated] = useState(false);
    const elementRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    if (animateOnce && hasAnimated) return;

                    setTimeout(() => {
                        setIsVisible(true);
                        if (animateOnce) {
                            setHasAnimated(true);
                        }
                    }, delay);
                } else if (!animateOnce) {
                    setIsVisible(false);
                }
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            }
        );

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => {
            if (elementRef.current) {
                observer.unobserve(elementRef.current);
            }
        };
    }, [delay, animateOnce, hasAnimated]);

    return (
        <div
            ref={elementRef}
            className={`fade-in-animation ${className}`}
            style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                transition: `opacity 0.6s ease-out ${delay}ms, transform 0.6s ease-out ${delay}ms`,
                ...style
            }}
        >
            {children}
        </div>
    );
};

export default FadeInAnimation; 